import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

const BebidasSection = ({
  bebidasFrias,
  bebidasCalientes,
  cart,
  setCart,
  openLightbox,
  openProductDetail,
  getImageUrl
}) => {
  if (bebidasFrias.length === 0 && bebidasCalientes.length === 0) return null;

  return (
    <section id="bebidas" className="py-20 px-6 bg-gradient-to-b from-amber-50 to-cream">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-chocolate mb-4">☕ Bebidas</h2>
          <p className="text-lg text-chocolate-light max-w-2xl mx-auto">
            Refrescantes bebidas frías y calientes para acompañar tus momentos especiales
          </p>
        </div>

        {bebidasFrias.length > 0 && (
          <div className="mb-12">
            <h3 className="text-2xl font-bold text-chocolate text-center mb-6">🧊 Bebidas Frías</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
              {bebidasFrias.map((item) => (
                <Card key={item.id} className="border-0 shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group">
                  {item.image && (
                    <div 
                      className="aspect-square overflow-hidden cursor-pointer relative"
                      onClick={() => openLightbox(getImageUrl(item.image), item.name)}
                    >
                      <img 
                        src={getImageUrl(item.image)} 
                        alt={`${item.name} – Brazolovers, Quito`}
                        loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100">
                        <span className="bg-white/90 text-chocolate px-3 py-1 rounded-full text-sm font-medium">
                          🔍 Ver imagen
                        </span>
                      </div>
                    </div>
                  )}
                  <CardContent className="p-4 space-y-2">
                    <h4 className="text-base font-bold text-chocolate text-center">{item.name}</h4>
                    {item.description && (
                      <p className="text-xs text-chocolate-light text-center line-clamp-2">{item.description}</p>
                    )}
                    <div className="text-center">
                      <span className="text-xl font-bold text-caramel">${item.price.toFixed(2)}</span>
                    </div>
                    <Button 
                      onClick={() => {
                        const cartItem = {
                          type: 'Bebida',
                          name: item.name,
                          size: 'Fría',
                          price: item.price,
                          quantity: 1
                        };
                        setCart([...cart, cartItem]);
                      }}
                      className="w-full bg-[#d4a574] hover:bg-[#c49564] text-white transition-colors duration-200"
                    >
                      Agregar al Pedido
                    </Button>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        )}

        {bebidasCalientes.length > 0 && (
          <div>
            <h3 className="text-2xl font-bold text-chocolate text-center mb-6">☕ Bebidas Calientes</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
              {bebidasCalientes.map((item) => (
                <Card key={item.id} className="border-0 shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group h-full flex flex-col">
                  {item.image && (
                    <div 
                      className="aspect-square overflow-hidden cursor-pointer relative"
                      onClick={() => openLightbox(getImageUrl(item.image), item.name)}
                    >
                      <img 
                        src={getImageUrl(item.image)} 
                        alt={`${item.name} – Brazolovers, Quito`}
                        loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100">
                        <span className="bg-white/90 text-chocolate px-3 py-1 rounded-full text-sm font-medium">
                          🔍 Ver imagen
                        </span>
                      </div>
                    </div>
                  )}
                  <CardContent className="p-4 space-y-3 flex-grow flex flex-col">
                    <h4 className="text-base font-bold text-chocolate text-center">{item.name}</h4>
                    {item.description && (
                      <p className="text-xs text-chocolate-light text-center line-clamp-2">{item.description}</p>
                    )}
                    <div className="flex-grow"></div>
                    <div className="text-center">
                      {item.hasOption && <span className="text-xs text-chocolate-light">desde </span>}
                      <span className="text-xl font-bold text-caramel">${item.price.toFixed(2)}</span>
                    </div>
                    <Button 
                      onClick={() => {
                        if (item.hasOption && item.options && item.options.length > 0) {
                          openProductDetail(item, 'bebida');
                        } else {
                          const cartItem = {
                            type: 'Bebida Caliente',
                            name: item.name,
                            size: 'Regular',
                            price: item.price,
                            quantity: 1
                          };
                          setCart([...cart, cartItem]);
                        }
                      }}
                      className="w-full bg-[#d4a574] hover:bg-[#c49564] text-white transition-colors duration-200"
                    >
                      {item.hasOption && item.options && item.options.length > 0 ? 'Ver Opciones' : 'Agregar al Pedido'}
                    </Button>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default BebidasSection;
